import { Subject } from "rxjs";

export const sessionSubject = new Subject<string>();
export const BH_LOGIN_URL = "https://www.wsmcasino.vip/en?overlay=auth&tab=login";
export const STATIC_NFT_IMG = "https://dl.openseauserdata.com/cache/originImage/files/cfbb56c6c930c347815d5fe493d798af.png";
export const STATIC_NFT = 'https://ipfs.io/ipfs/QmcDeVYgKVLk4Mqej1iCG6Ld7WSSow7vVnXgkn2EG9w9kb';

export const MESSAGES = {
    SOMETHING_WENT_WRONG: 'Something went wrong!',
    REQUESTED_DATA_UNAVAILABLE: "Requested data is not available!",
    INTERNET_RESTORED : 'Internet connection restored!',
    INTERNET_DISCONNECTED: 'No internet connection!',
    GAME_INACTIVE: "Game no longer active!",
    PRIZE_UPDATED: "Prizes got updated!"
}

export const ROUTES = {
    LOOTBOX: 'lootboxes'
}

export const SPINNER_GRADIENT_COLORS = [
    'rgba(20, 20, 20, 1)',
    'rgba(20, 20, 20, 0.8)',
    'rgba(20, 20, 20, 0.6)',
    'rgba(20, 20, 20, 0.4)',
    'rgba(20, 20, 20, 0.2)',
    'rgba(20, 20, 20, 0)',
]
